jQuery(document).ready(function($) {
    const $blocks = $('.wp-block-jormi-blocks-custom-menu');
    
    if ($blocks.length) {
        $blocks.each(function() {
            const $block = $(this);
            const $menuPanel = $block.find('[data-menu-panel]');
            const $menuTrigger = $block.find('[data-menu-trigger]');
            const $elems = $block.find('.wp-block-navigation-item, .wp-block-button, p');
            const $buttons = $block.find('.wp-block-button');

            let menuTl;
            
            if (typeof gsap !== 'undefined' && $menuPanel.length) {
                // Initial states
                gsap.set($menuPanel, {
                    xPercent: 100,
                    visibility: 'hidden'
                });
                
                // Animation timeline
                menuTl = gsap.timeline({
                    paused: true,
                    defaults: {
                        duration: 0.8,
                        ease: 'expo.inOut'
                    }
                });                
                menuTl.to($menuPanel, {
                    xPercent: 0,
                    visibility: 'visible'
                })
               
            }
            
            // Menu trigger logic
            if ($menuTrigger.length && $menuPanel.length) {
                $menuTrigger.on('click', function() {
                    const isExpanded = $(this).attr('aria-expanded') === 'true';
                    
                    if (!isExpanded) {
                        // Opening the menu
                        if (typeof gsap !== 'undefined' && menuTl) {
                            $menuPanel.removeClass('invisible hidden');
                            menuTl.play();
                        } else {
                            $menuPanel.removeClass('invisible hidden');
                        }
                        
                        // Remove the menu-closing class if exists
                        $menuTrigger.removeClass('menu-closing');
                        
                        $menuTrigger.css('zIndex', '999');
                        $menuTrigger.css('position', 'relative');
                        $('html').css('overflowY', 'hidden');
                        $menuTrigger.attr('aria-expanded', 'true');
                        $menuTrigger.addClass('active');
                        
                    } else {
                        // Closing the menu - first add the closing class for animation
                        $menuTrigger.addClass('menu-closing');
                        
                        if (typeof gsap !== 'undefined' && menuTl) {
                            // Reverse animation
                            menuTl.reverse();
                            // After animation completes, add hidden class back
                            menuTl.eventCallback('onReverseComplete', function() {
                                $menuPanel.addClass('invisible hidden');
                                
                                setTimeout(function() {
                                    $('html').css('overflowY', 'auto');
                                    $menuTrigger.attr('aria-expanded', 'false');
                                    $menuTrigger.removeClass('active');
                                    
                                    // Need to keep the menu-closing class long enough for the animation to complete
                                    // Then remove it to prevent it from starting again on page load
                                    setTimeout(function() {
                                        $menuTrigger.removeClass('menu-closing');
                                    }, 650); // Slightly longer than animation duration
                                }, 50);
                            });
                        } else {
                            // Fallback
                            $menuPanel.addClass('invisible hidden');
                            $('html').css('overflowY', 'auto');
                            $menuTrigger.attr('aria-expanded', 'false');
                            $menuTrigger.removeClass('active');
                            
                            setTimeout(function() {
                                $menuTrigger.removeClass('menu-closing');
                            }, 650);
                        }
                    }
                });
            }
        });
    }
});